module.exports = __webpack_public_path__ + "img/freespin1_multiplier1.ae28455d.png";